import React, { useRef, useState } from "react";
import { SelectBoxItem, SelectBox, CustomCalendar } from "../../../components";
import { SettingIcon, DownIcons } from "../../../components/Icons/Icons";
import classNames from "classnames/bind";
import styles from "./Filter.module.css";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

const Filter = ({
  onChangeDayStart,
  timeStart,
  setType,
  showModalDl,
  setShowModalDl,
  day,
  setSpeedPB,
  speedPB
}) => {
  const ref = useRef(null)
  const btnRef = useRef(null)
  const [speed, setSpeed] = useState([
    {
      name: "x1",
      value: 1,
    },
    {
      name: "x2",
      value: 2,
    },
    {
      name: "x4",
      value: 4,
    },
    {
      name: "x6",
      value: 6,
    },
    {
      name: "x8",
      value: 8,
    },
    {
      name: "x16",
      value: 16,
    },
  ]);
  const [showSpeed, setShowSpeed] = useState(false);
  const { t } = useTranslation()
  React.useEffect(() => {
    let handler = (e) => {
      if (!ref?.current?.contains(e.target) && !btnRef?.current?.contains(e.target)) {
        setShowSpeed(false);
      }
    };

    document.addEventListener("click", handler);

    return () => {
      document.removeEventListener("click", handler);
    };
  }, []);
  return (
    <div className={cx("filter")}>
      <div style={{ flex: 1 }}>
        <CustomCalendar
          onChange={onChangeDayStart}
          dayHl={day}
          value={timeStart}
          title={t("playback.choseDay")}
        />
      </div>
      <div style={{ flex: 1, width: "100%" }}>
        <label className={cx("label-time")}>{t("playback.timeFrame")}</label>
        <SelectBox
          style={{
            width: "100%",
          }}
          values={`24h`}
          onChange={(data) => setType(data)}
          type="small"
        >
          <SelectBoxItem label={"12h"} value={12} />
          <SelectBoxItem label={"24h"} value={24} />
        </SelectBox>
      </div>
      <div className={cx("download")}>
        <button
          onClick={() => {
            setShowModalDl(!showModalDl);
          }}
          className={cx("btn", "ok")}
        >
          {t("playback.downLoad")}
        </button>
        {showSpeed && (
          <div ref={ref} className={cx("speed")}>
            {speed.map((item, index) => {
              return (
                <div
                  onClick={() => {
                    setSpeedPB(item);
                    setShowSpeed(false)
                  }}
                  className={cx("speed-item")}
                  key={index}
                  style={item.value === speedPB ? { background: "#F7F8FC" } : {}}
                >
                  <span className={cx("speed-value")}>{item.name}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Filter;
